module.exports = __webpack_public_path__ + "static/media/faq-preferences.b931ebcb.png";